import React from 'react';
import PropTypes from 'prop-types';
import { ChevronLeft } from 'lucide-react';

import INITIAL_VALUE from 'constants/initialValue';
import formatDate from 'utils/formatDate';
import formatMoney from 'utils/formatMoney';
import { BOOKING_STATUS, ROOM_TYPE } from 'constants/index';

import styles from './BookingInfo.module.scss';

function BookingInfo(props) {
  const { chatRoomDetail, isLoading, onBack } = props;

  const renderHeader = () => onBack && (
    <div className={styles.Header}>
      <button
        type="button"
        className={styles.BackButton}
        aria-label="Quay lại tin nhắn"
        onClick={onBack}
      >
        <ChevronLeft size={24} />
      </button>
      <h3 className={styles.HeaderTitle}>Thông tin đặt phòng</h3>
    </div>
  );

  if (isLoading) {
    return (
      <div className={`${styles.BookingInfo} ${styles.BookingInfoLoading}`}>
        {renderHeader()}
        <div className={styles.BookingInfoLoadingContent}>Đang tải...</div>
      </div>
    );
  }

  return (
    <div className={styles.BookingInfo}>
      {renderHeader()}
      <div className={styles.Summary}>
        <div className={styles.SummaryRow}>
          <span className={styles.SummaryLabel}>Mã đặt phòng:</span>
          <button type="button" className={styles.BookingCode}>
            {chatRoomDetail?.booking?.orderId}
          </button>
        </div>
        <div className={styles.SummaryRow}>
          <span className={styles.SummaryLabel}>Tình trạng:</span>
          <span>{BOOKING_STATUS[chatRoomDetail?.booking?.bookingStatus]?.label}</span>
        </div>
        <div className={styles.SummaryRow}>
          <span className={styles.SummaryLabel}>Tổng giá:</span>
          <span>
            {formatMoney.format(chatRoomDetail?.booking?.totalDiscountedPrice
               || chatRoomDetail?.booking?.totalPrice)}
          </span>
        </div>
      </div>

      <div className={styles.DetailList}>
        <div className={styles.DetailRow}>
          <span className={styles.DetailLabel}>Tên phòng</span>
          <span className={styles.DetailValue}>
            {chatRoomDetail?.booking?.rooms?.[0]?.parentRoomName
              ? ROOM_TYPE[chatRoomDetail?.booking?.rooms?.[0]?.parentRoomName]?.label
              : chatRoomDetail?.booking?.rooms?.[0]?.name}
          </span>
        </div>

        <div className={styles.DetailRow}>
          <span className={styles.DetailLabel}>Ngày nhận phòng</span>
          <span className={styles.DetailValue}>
            {formatDate(chatRoomDetail?.booking?.startedAt)}
          </span>
        </div>

        <div className={styles.DetailRow}>
          <span className={styles.DetailLabel}>Ngày trả phòng</span>
          <span className={styles.DetailValue}>
            {formatDate(chatRoomDetail?.booking?.endedAt)}
          </span>
        </div>

        <div className={styles.DetailRow}>
          <span className={styles.DetailLabel}>Số phòng</span>
          <span className={styles.DetailValue}>
            {chatRoomDetail?.booking?.rooms?.[0]?.roomQuantity}
          </span>
        </div>

        <div className={styles.DetailRow}>
          <span className={styles.DetailLabel}>Người lớn</span>
          <span className={styles.DetailValue}>
            {chatRoomDetail?.booking?.adults}
          </span>
        </div>

        <div className={styles.DetailRow}>
          <span className={styles.DetailLabel}>Trẻ em</span>
          <span className={styles.DetailValue}>
            {chatRoomDetail?.booking?.children}
          </span>
        </div>
      </div>
    </div>
  );
}

BookingInfo.propTypes = {
  chatRoomDetail: PropTypes.instanceOf(Object),
  isLoading: PropTypes.bool,
  onBack: PropTypes.func,
};

BookingInfo.defaultProps = {
  chatRoomDetail: INITIAL_VALUE.OBJECT,
  isLoading: false,
  onBack: null,
};

export default BookingInfo;
